import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {renderIf, renderIfElse} from "../../../Shared";
import {BrideIconOutlineSvg, GroomIconOutlineSvg} from "../../../../components/Svgs/ParentIconSvg";

import {Button} from "antd";
import {renderEmptyHolderMember} from "../../../AppLocals/CatholicHousehold/functions/renderEmptyHolderMember";
import {ParentMemberItemInfo} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {HeaderWithIconLine} from "../../../AppLocals/Templates/items/ListHeader";
import {useCatholicHouseholds} from "../../../AppLocals/CatholicHousehold/functions/useCatholicHouseholds";
import {notifyOnError} from "../../../AppLocals/factory/createErrorEvent";
import {IoCloseCircleOutline, IoWarning} from "react-icons/io5";
import CatholicHouseholdChangeLogs from "../containers/CatholicHouseholdChangeLogs";
import {showConfirmDialog} from "../../../AppLocals/factory/createConfirmDialog";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import {BsCheckLg, BsHouseFill} from "react-icons/bs";
import {ItemInfoGrid} from "../../../../components/common/ItemInfoGrid";
import {ItemInformation} from "../../../../components/common/ItemInformation";
import {DoubleValueItem} from "../../../../components/common/DoubleValueItem";


export const CatholicHouseholdApproveForm = ({item, onCancel}) => {
    const t = useTranslate()
    const members = _.get(item, 'catholic_household_members', []);
    const householdFather = _.first(members.filter(e => e.id === _.get(item, 'household_father.id')))
    const householdMother = _.first(members.filter(e => e.id === _.get(item, 'household_mother.id')))
    const householdMotherMatrimony = _.find(_.get(householdMother, 'sacraments', []), {sacrament_type: 'matrimony'})
    const householdFatherMatrimony = _.find(_.get(householdFather, 'sacraments', []), {sacrament_type: 'matrimony'})

    const onRefresh = () => {
        onCancel();
    }

    const onError = notifyOnError(t)

    const {onChangeStatus} = useCatholicHouseholds({
        owner_type: item?.owner_type,
        owner_id: item?.owner_id,
        notifyListeners: {
            onStatusChanged: onRefresh,
        },
    })

    return (
        <div className="flex flex-col">

            {/* ─── Modal header ─────────────────────────────── */}
            <div className="px-5 pt-5 pb-4 border-b border-color-50">
                <div className="flex items-start gap-3">
                    <div
                        className="flex-none w-10 h-10 rounded-xl flex items-center justify-center"
                        style={{background: 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)'}}>
                        <BsHouseFill size={18} className="text-indigo-500"/>
                    </div>
                    <div className="flex flex-col flex-1 min-w-0">
                        <div className="font-bold text-lg text-color-000 tracking-wide leading-snug">
                            {`${t('catholic household')} ${item?.title}`}
                        </div>
                        <div className="flex flex-wrap items-center gap-x-3 mt-0.5">
                            <DoubleValueItem
                                labelFirst="number"
                                valueFirst={item?.source_idcode ?? t('not update')}
                                labelSecond="belong to"
                                valueSecond={item?.parish?.fullname || item?.parish_name}
                                className="text-xs"
                            />
                            {renderIf(
                                item?.eff_date,
                                <ItemInformation
                                    label="date of immigration"
                                    value={formatDate(item?.eff_date, 'DD/MM/YYYY')}
                                    className="text-xs"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* ─── Scrollable body ──────────────────────────── */}
            <div className="flex flex-col gap-5 px-5 py-4 overflow-y-auto" style={{maxHeight: '60vh'}}>

                {/* Change log */}
                <CatholicHouseholdChangeLogs item={item}/>

                {/* Matrimony certificate */}
                <div className="flex flex-col gap-3">
                    <HeaderWithIconLine
                        center={true}
                        lineColor="border-green-200"
                        renderTitle={() => (
                            <span
                                className="font-semibold text-sm text-green-600 tracking-widest uppercase leading-tight">
                                {t('church marriage certificate')}
                            </span>
                        )}
                        className="w-full"
                    />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-1.5">
                                <GroomIconOutlineSvg size={16} className="text-blue-500"/>
                                <span className="font-semibold text-sm text-blue-600 tracking-wider">
                                    {t('the groom side')}
                                </span>
                            </div>
                            {renderIfElse(
                                householdFather,
                                <ParentMemberItemInfo item={householdFather}/>,
                                renderEmptyHolderMember("no data is available now", "household mother description")
                            )}
                        </div>
                        <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-1.5">
                                <BrideIconOutlineSvg size={16} className="text-pink-500"/>
                                <span className="font-semibold text-sm text-pink-600 tracking-wider">
                                    {t('the bride side')}
                                </span>
                            </div>
                            {renderIfElse(
                                householdMother,
                                <ParentMemberItemInfo item={householdMother}/>,
                                renderEmptyHolderMember("no data is available now", "household mother description")
                            )}
                        </div>
                    </div>

                    {renderIf(
                        householdFatherMatrimony,
                        <div className="mt-2 p-3 bg-green-50 border border-green-100 rounded-xl flex flex-col gap-2">
                            <div className="text-center">
                                <div className="font-semibold text-sm text-green-700 uppercase tracking-wider">
                                    {t('the sacrament of matrimony was celebrated')}
                                </div>
                                <div className="space-x-1 mt-0.5">
                                    {renderIf(
                                        !!householdFatherMatrimony?.eff_date,
                                        <React.Fragment>
                                            <span className="text-xs text-color-300 italic lowercase">{t('date')}</span>
                                            <span className="text-xs font-semibold text-green-700">
                                                {formatDate(householdFatherMatrimony?.eff_date, 'DD/MM/YYYY')}
                                            </span>
                                        </React.Fragment>
                                    )}
                                    {renderIf(
                                        !!householdFatherMatrimony?.parish_name,
                                        <React.Fragment>
                                            <span className="text-xs text-color-300 italic lowercase">{t('in')}</span>
                                            <span className="text-xs font-semibold text-green-700">
                                                {householdFatherMatrimony?.parish_name}
                                            </span>
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                                <ItemInfoGrid center={true} label="presiding priest"
                                              value={householdFatherMatrimony?.officiant_name}
                                              className="text-xs"/>
                                <ItemInfoGrid center={true} label="marriage book no"
                                              value={householdFatherMatrimony?.source_idcode}
                                              className="text-xs"/>
                                <ItemInfoGrid center={true} label="marriage witnesses 1"
                                              value={householdFatherMatrimony?.participant_name}
                                              className="text-xs"/>
                                <ItemInfoGrid center={true} label="marriage witnesses 2"
                                              value={householdMotherMatrimony?.participant_name}
                                              className="text-xs"/>
                            </div>
                        </div>
                    )}
                </div>

                {/* Contact info */}
                <div className="flex flex-col gap-1.5">
                    <HeaderWithIconLine
                        center={true}
                        lineColor="border-color-100"
                        renderTitle={() => (
                            <span className="font-semibold text-xs text-color-400 tracking-widest uppercase">
                                {t('contact information')}
                            </span>
                        )}
                        className="w-full"
                    />
                    <ItemInformation showIcon={true} label="contact name" value={item?.contact_name}
                                     className="text-sm"/>
                    <DoubleValueItem
                        showIcon={true}
                        labelFirst="phone"
                        valueFirst={item?.contact_phone}
                        labelSecond={(item?.contact_phone2 && " - ") || ''}
                        valueSecond={item?.contact_phone2}
                        className="text-sm"
                    />
                    <ItemInformation showIcon={true} label="address" value={item?.contact_address} className="text-sm"/>
                </div>
            </div>

            {/* ─── Footer CTA ───────────────────────────────── */}
            <div className="px-5 py-3 border-t border-color-50 flex items-center justify-between gap-3">
                <Button
                    color="danger"
                    variant="outlined"
                    icon={<IoCloseCircleOutline size={15}/>}
                    onClick={() => {
                        showConfirmDialog({
                            translate: t,
                            icon: <IoWarning className="anticon"/>,
                            title: 'reject household',
                            message: 'are you sure you want to reject this household',
                            onOk: () => {
                                onChangeStatus({status: -2}, {id: item?.id})
                            },
                        })
                    }}>
                    {t('reject')}
                </Button>
                <div className="flex items-center gap-2">
                    <Button
                        variant="text"
                        color="default"
                        onClick={onCancel}>
                        {t('close')}
                    </Button>
                    <Button
                        color="primary"
                        variant="solid"
                        icon={<BsCheckLg size={13}/>}
                        onClick={() => {
                            onChangeStatus({status: 1}, {id: item?.id})
                        }}>
                        {t('approve')}
                    </Button>
                </div>
            </div>
        </div>
    )
}
